import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import Expense from "./Expense";
import Document from "./Document";
import { NavLink } from 'react-router-dom';
import Conflicts from "../Conflicts/Conflicts";

export default class Expenses extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'expense',
            data: null,
            loading: true,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            filters: {
                filter: 0,
                documentNumber: '',
                expenseNumber: '',
                currentAnnual: this.isNull(props.CurrentAnnual) ? true : props.CurrentAnnual,
            },
            systemModuleId: 4,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            sort: '',
            menuId: 234,
            currentConflictId: null,
            conflicts: []
        };

        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
                this.getConflicts();
            });
    }
    getConflicts() {
        this.httpPost("api/v1/conflict/list", {
            filters: {
                usage: 6
            }
        })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ conflicts: data.records });
                }
            });
    }
    showConflicts() {
        this.showComponents({ component: <Conflicts Caller={this} Usage={6} /> });
    }
    saveChecked(entityRecordId, checked) {
        if (this.isBlank(this.state.currentConflictId)) return;
        var conflictId = this.state.currentConflictId;

        this.httpPost("api/v1/conflict/check", {
            usage: 6,
            conflictId,
            entityRecordId,
            checked
        }, false)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });

        this.state.data.records.forEach(f => {
            if (f.id === entityRecordId) {
                var tempConflicts = [];
                f.conflicts.forEach(c => {
                    if (c !== conflictId) tempConflicts.push(c);
                });
                if (checked) tempConflicts.push(conflictId);
                f.conflicts = tempConflicts;
            }
        });

        this.setState({ data: this.state.data });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Expense Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Expense Caller={this} /> });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        {this.state.inline === false && <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست دفاتر هزینه</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} دفتر یافت شد</p>
                            </div>
                        </div>}
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em>
                                                <span>ثبت دفتر جدید</span>
                                            </a>
                                        </li>
                                        {this.state.inline === false && <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            {/*<div className="form-wrap">*/}
                                            {/*    <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="طرف حساب" className="form-control" />*/}
                                            {/*</div>*/}
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.expenseNumber} onChange={e => this.state.filters.expenseNumber = e.target.value} placeholder={"شماره"} className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.documentNumber} onChange={e => this.state.filters.documentNumber = e.target.value} placeholder="شماره سند" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.filter} onChange={e => this.state.filters.filter = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">فاقد فیلتر</option>
                                                    <option value="1">فاقد سند</option>
                                                    <option value="2">دارای سند</option>
                                                    <option value="3">قطعی شده</option>
                                                    <option value="4">پیش نویس</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.sort} onChange={e => this.state.sort = e.target.value} className="form-control">
                                                    <option value="">شماره (نزولی)</option>
                                                    <option value="number">شماره (صعودی)</option>
                                                    <option value="-date">جدید به قدیم</option>
                                                    <option value="date">قدیم به جدید</option>
                                                    {/*<option value="-docnumber">شماره سند (نزولی)</option>*/}
                                                    {/*<option value="docnumber">شماره سند (صعودی)</option>*/}
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ فاکتوری یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">از تاریخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تا تاریخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مبلغ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                            <div className="nk-tb-col text-end" style={{ display: "flex", gap: "5px", padding: "5px" }}>
                                                <select defaultValue={this.state.currentConflictId} onChange={e => this.setState({ currentConflictId: e.target.value })} className="form-control">
                                                    <option value="">انتخاب مغایرت</option>
                                                    {this.state.conflicts.map(con => <option value={con.id}>{con.name}</option>) }
                                                </select>
                                                <a onClick={e => this.showConflicts()} className="hand text-primary"><i className="fa fa-list"></i></a>
                                            </div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className={"nk-tb-item " + (record.conflicts.includes(this.state.currentConflictId) ? "highlighted" : "")} key={record.id + "_" + this.state.currentConflictId}>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.number}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">سند: </span>
                                                    {record.documents.map(rmt =>
                                                        <span className="sub-text text-center" style={{ marginLeft: "5px" }}><a onClick={e => this.showDocument(rmt.id)} className="text-primary txt-bold hand">{rmt.number}</a></span>
                                                    )}
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">از تاریخ: </span>
                                                    <span className="sub-text text-center">{record.fromDateString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تا تاریخ: </span>
                                                    <span className="sub-text text-center">{record.toDateString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">مبلغ: </span>
                                                    <span className="sub-text text-center">{this.money(record.total)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">وضعیت: </span>
                                                    <span className="sub-text text-center">{record.statusString}</span>
                                                </div>
                                                <div className="nk-tb-col text-end">
                                                    {!this.isBlank(this.state.currentConflictId) && <input type="checkbox" key={record.id + "_" + this.state.currentConflictId} defaultChecked={record.conflicts.includes(this.state.currentConflictId)} onChange={e => this.saveChecked(record.id, e.target.checked)} />}
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        <em className="icon ni ni-cross-fill-c"></em>
                                                    </a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                        <em className="icon ni ni-pen"></em>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline === false && <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),

            ];
        return contents;
    }
}